module.exports = __webpack_public_path__ + "img/comprehensive-report.a4913f1f.jpeg";